// Add code: <div product-id="{{ product.id }}" class="arv-collection arv-collection--{{ product.id }}"></div>
import { getRatingCollection } from './fetch-rating';
import { createRating } from './rating';
import { addEventShowRatingDetail } from './product-raitng';

function insertRating(
  icon_color,
  icon_content,
  eleDisplay,
  product_id,
  avg_rating,
  text_review,
  is_duplicate_rating = false,
  is_transcy_connected = false,
  is_show_detail_on_hover
) {
  let classTranslate = is_transcy_connected ? '' : '';
  let style = `
  <style>
  .arv-collection .rating-symbol-foreground > span,
  .arv-collection .alr-rating-symbol-foreground > span,
  .arv-collection .rating-symbol-background,
  .arv-collection .alr-rating-symbol-background,
  #alireview-review-widget-badge .rating-symbol-foreground > span,
  .alireview-review-widget-badge .rating-symbol-foreground > span,
  #alireview-review-widget-badge .rating-symbol-background,
  .alireview-review-widget-badge .rating-symbol-background,
  #alireview-review-widget-badge .alr-rating-symbol-foreground > span,
  .alireview-review-widget-badge .alr-rating-symbol-foreground > span,
  #alireview-review-widget-badge .alr-rating-symbol-background,
  .alireview-review-widget-badge .alr-rating-symbol-background {
      color :${icon_color}  !important;
  }
  .arv-collection .alr-icon-star:before,
  #alireview-review-widget-badge .alr-icon-star:before,
  .alr-rating-detail[data-alr-rating-detail] .alr-icon-star:before {
    content:"${icon_content}" !important;
  }
  .arv-collection .alr-wrapper-rating > svg {
    margin-left: 0px !important;
  }
  </style>`;
  let creatRatingEle = createRating(avg_rating, is_show_detail_on_hover)
  let rating = `
  <div class="alrv-prod-rating-${product_id} ${classTranslate}">
    ${creatRatingEle}
    <span class="alrv-prod-rating__text" style="margin-left: 4px;">
      ${text_review}
    </span>
  </div>`;
  const eleRating = `${style} ${rating} ${is_duplicate_rating ? rating : ''}`;

  eleDisplay.insertAdjacentHTML("afterbegin", eleRating);
}

export default function addRatingCollection() {
  const divProdCollections = document.getElementsByClassName("arv-collection");
  if (divProdCollections.length > 0) {
    let arr_pro_ids = [];
    Array.from(divProdCollections).forEach(function (el) {
      let value = el.getAttribute("product-id");
      if (value) {
        arr_pro_ids.push(value);
      }
    });
    if (arr_pro_ids.length > 0) {
      checkLengthProducts(arr_pro_ids);
    }
  }
}

// Get products every time max 100 products
function checkLengthProducts(product_ids) {
  const number_max = 100;
  if (product_ids.length > number_max) {
    let list_product_ids_max_100 = product_ids.slice(0, number_max);
    let list_product_ids_exist = product_ids.slice(number_max, product_ids.length);
    showRatingCollection(list_product_ids_max_100);
    checkLengthProducts(list_product_ids_exist);
    return;
  }
  showRatingCollection(product_ids);
}



// Call Ajax get rating by product id
async function showRatingCollection(product_ids) {
  try {

    let rs = await getRatingCollection({ product_ids });
    if (rs.status) {
      let result = rs.data;
      const avg_rating = result.hasOwnProperty("avg_star")
        ? result.avg_star
        : {};
      const total_review = result.hasOwnProperty("total_review")
        ? result.total_review
        : {};
      const is_duplicate_rating = result.hasOwnProperty("issue") && result.issue == 'duplicate'
        ? true
        : false;
      const is_transcy_connected = result.hasOwnProperty("is_transcy_connected")
        ? result.is_transcy_connected
        : false;
      const is_show_detail_on_hover = result.hasOwnProperty("is_show_detail_on_hover") ? result.is_show_detail_on_hover : false;
      // extract key from result.avg_rating
      const avg_key = Object.keys(avg_rating);
      avg_key.length && avg_key.map(function (productId) {
        if (avg_rating[productId] > 0) {
          const eleDisplay = document.getElementsByClassName(
            "arv-collection--" + productId
          );
          // const text = (total_review[productId] == 0 || total_review[productId] == 1) ? result["text_review_singular"] : result["text_review_plural"];
          // const text_review = total_review[productId] + " " + text;
          const text_review = total_review[productId];
          for (var i = 0; i < eleDisplay.length; i++) {
            if (eleDisplay[i].childElementCount == 0) {
              eleDisplay[i].style.display = "none";
              insertRating(
                result.icon_color,
                result.icon_content,
                eleDisplay[i],
                productId,
                avg_rating[productId],
                text_review,
                is_duplicate_rating,
                is_transcy_connected,
                is_show_detail_on_hover
              );
            }
          }
        }
      })
      
      addEventShowRatingDetail(result.icon_color);
    }
  } catch (error) {
    console.log(error)
  }
}
